// robot-nav-html-* 子组件的通用数据
export default {
  inject: ['globalData'],
  props: {
    // 导航数据
    navData: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  computed: {
    isMobile() {
      return !this.$platform.pc;
    },
  },
  data() {
    return {
      // 当前tab，多分组菜单有效
      currentTab: 0,
      // 转接一下数据
      robotNav: this.navData,
    };
  },
  methods: {
    // 点击处理
    onClick(info, extData = null) {
      console.log('onClick');
      this.$emit('click', info, extData);
    },

    // 获得分页数据
    getPageData(c, perPageCount) {
      console.log('getPageData', c, perPageCount);
      const index = c.index || 1;
      const pageCount = c.pageCount || perPageCount || 6;
      let total = c.total || 0;

      let tmpData = c.list || [];

      if (c.source === 2) {
        if (c.list.length > pageCount && c.more_questions === 1) {
          this.$set(c, 'showChange', true);
          tmpData = c.list.slice(pageCount * (index - 1), pageCount * index);
        } else {
          this.$set(c, 'showChange', false);
        }
        total = Math.ceil(c.list.length / pageCount);
      }
      this.$set(c, 'index', index);
      this.$set(c, 'pageCount', pageCount);
      this.$set(c, 'total', total);
      return tmpData;
    },
    // 换页
    onChange(c) {
      let index = c.index || 1;
      const total = c.total || 0;
      index < total ? (index += 1) : (index = 1);
      this.$set(c, 'index', index);
      // 刷新数据
      this.$forceUpdate();
    },
    /**
     * 切换tab
     */
    onChangeTab(index, info) {
      console.log('onChangeTab：', index, info);
      this.currentTab = index;

      // 主要是触发上报，所以这里不带info的值，因为不需要发送消息
      this.onClick({}, { robot_nav_first_menu_id: 0, robot_nav_first_menu_name: info.tit, robot_nav_action_type: 7 });
    },
  },
};
